module.exports = __webpack_public_path__ + "static/media/1382_1920_old.2143c89a.jpg";